"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCsvCompatibleField = void 0;
var const_1 = require("../const");
exports.isCsvCompatibleField = function (field, isKit) {
    if (isKit === void 0) { isKit = true; }
    return !field.aggregate && __spreadArrays(["_id", "photo"], const_1.fixedUserfields.map(function (field) { return field.name; }), (isKit ? ["updatedAt", "createdAt"] : [])).includes(field.name);
};
//# sourceMappingURL=csv.js.map